import React, { Component } from "react";

class NavigationOverviewLinkListItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <li className="navigation-overview__link-list__item">
                <a href={this.props.Url} title={this.props.Text}>
                    {this.props.Text}
                </a>
            </li>
        );
    }
}
export default NavigationOverviewLinkListItem;
